import { render, staticRenderFns } from "./member_grouping.vue?vue&type=template&id=35ac6c0c&scoped=true"
import script from "./member_grouping.vue?vue&type=script&lang=js"
export * from "./member_grouping.vue?vue&type=script&lang=js"
import style0 from "./member_grouping.vue?vue&type=style&index=0&id=35ac6c0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ac6c0c",
  null
  
)

export default component.exports